import { useQuery } from '@tanstack/react-query'

import { CombinationItemViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

interface Props {
    brand_id: string
}

export function useGetBrandCombinationsList({ brand_id }: Props) {
    return useQuery<CombinationItemViewModel[]>({
        queryKey: QueryKeys.PLP.BrandCategoriesCombinationList(brand_id),
        queryFn: () => {
            return fetchRequest({
                endpoint: `/combinations/brand/${brand_id}`,
                method: 'GET',
                serviceName: 'cml',
            })
        },
        enabled: !!brand_id,
    })
}
